import Nd1SiteNav from "./Nd1SiteNav";
import Nd1SiteFooter from "./Nd1SiteFooter";

/** Shared ND1 wrapper for sign-in, sign-up, and related auth flows. */
export default function Nd1AuthShell({ children, hideFooter = false }) {
  return (
    <div className="nd1-root nd1-auth-page">
      <a href="#nd1-main" className="nd1-skip-link">
        Skip to content
      </a>
      <Nd1SiteNav />
      {children}
      {hideFooter ? null : <Nd1SiteFooter />}
    </div>
  );
}
